// Styles for LuxuryCarousel go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLuxuryCarousel = styled.div`
  .color-class {
    .glide__bullet--active::after {
      background-color: ${baseVariables.color['base20']};
    }
  }
  .header-text-cta-styles {
    padding: ${toRem(24)} 0;
  }

  .only-header-styles {
    .header-text-heading {
      padding: ${toRem(16)} 0 !important;
      margin-bottom: 0 !important;
      @media ${baseVariables.mediaQuery.lg} {
        padding: ${toRem(24)} 0 !important;
      }
    }
  }
`;

export const StyledCardCarouselContainer = styled.div`
  clear: both;
`;
